import { IProvideComponentLastEditedTracker, IComponentLastEditedTracker } from '@fluidx/office-fluid-types';
import { IFluidObject } from '@fluidframework/core-interfaces';
import { EventEmitter } from 'events';

/**
 * An event emitter which can be used to provide last edit information.
 */
export class LastEditedTracker extends EventEmitter implements IProvideComponentLastEditedTracker {
  private lastEditedComponent: IComponentLastEditedTracker | undefined;

  constructor(private readonly lastEditedComponentPromise: Promise<IFluidObject | undefined>) {
    super();
    this.initialize();
  }

  public get IComponentLastEditedTracker() {
    return this;
  }

  public getLastEditDetails() {
    return this.lastEditedComponent?.getLastEditDetails();
  }

  private initialize() {
    // tslint:disable-next-line: no-floating-promises
    this.lastEditedComponentPromise.then((component) => {
      if (!component || !component.IComponentLastEditedTracker) {
        return;
      }

      this.lastEditedComponent = component.IComponentLastEditedTracker;

      if (this.lastEditedComponent.on && this.lastEditedComponent.once) {
        // Propagate the event further.
        // This allows us to propagate the event coming from the real LastEditedComponent
        // to the outside of the default component.
        this.lastEditedComponent.on('lastEditChanged', () => this.emit('lastEditChanged'));

        // Inform hosts that the component has loaded so that they can do their setup.
        this.emit('lastEditedComponentLoaded');

        // Only the Root Component holds a direct reference to the real LastEditedComponent,
        // The other components actually hold a reference to a LastEditedTracker,
        // so we need to listen and plumb this event when the LastEditedComponent actually emits it.
        this.lastEditedComponent.once('lastEditedComponentLoaded', () => this.emit('lastEditedComponentLoaded'));
      }
    });
  }
}
